import React from 'react';
import PropTypes from 'prop-types';
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
//import 'react-awesome-slider/dist/styles.css';
import AwesomeSliderStyles from "react-awesome-slider/dist/styles.css?raw";

const AutoplaySlider = withAutoplay(AwesomeSlider);

const Awesome = ({
  children,
  play,
  cancelOnInteraction,
  interval,
  theme
}) => {
  return (
    <AutoplaySlider
      play={play}
      cancelOnInteraction={cancelOnInteraction} // should stop playing on user interaction
      interval={interval}
      style={{ backgroundColor: theme.background }} // Apply the theme background color
    >
      {children.length &&
        children.map((child) => (
          <div key={child.key}>{child}</div>
        ))}
    </AutoplaySlider>
    );
};

Awesome.propTypes = {
  children: PropTypes.node,
  play: PropTypes.bool,
  cancelOnInteraction: PropTypes.bool,
  interval: PropTypes.number,
  theme: PropTypes.shape({
    background: PropTypes.string,
    text: PropTypes.string,
    divider: PropTypes.string,
    highlight: PropTypes.string,
  })
};

Awesome.defaultProps = {
  children: null,
  play: true,
  cancelOnInteraction: false,
  interval: 6000,
  theme: {
    background: '#ffffff',
    text: '#000000',
    divider: '#cccccc',
    highlight: '#ff0000',
  }
};

export default Awesome;
